<template>
    <div class="row">
        <div v-for="category in categories" class="col-12 col-lg-6 col-xl-4 col-xxl-3 pb-4" :key="category._id">
            <categories-list-category :category="category" :grouping="grouping"/>
        </div>
    </div>
</template>

<script>

    import CategoriesListCategory from "@/components/categories/CategoriesListCategory";

    export default {
        name: "CategoriesList",
        components: {
            CategoriesListCategory
        },
        props: {
            categories: {
                type: Array,
                required: true
            },
            grouping: {
                type: String,
                required: true
            }
        }
    }
</script>